<div class="main-content">
  @if (workflow.message) { <div class="container alert alert-warning" role="alert">{{ workflow.message }}</div> }
  @if (state.showProcess) {
    <section class="access">
      <div class="container" role="status" aria-live="polite">
        <h1>お申し込みを処理しています...</h1>
        <p>画面を閉じずに、このまましばらくお待ちください。</p>
      </div>
    </section>
  } @else if (state.showConfirm) {
  <section class="access">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-xs-12">
          @if (!member.visitors) {
            <ul class="step">
              <li><span [class.en]="member.translate === 'en'">{{ 'selectAGymBranch' | translate }}</span></li>
              <li><span [class.en]="member.translate === 'en'">{{ 'enterYourDetails' | translate }}</span></li>
              <li class="active"><span>{{ 'confirm' | translate }}</span></li>
              <li><span>{{ 'complete' | translate }}</span></li>
            </ul>
          }
          <div class="clearfix"></div>
          <div class="application">

            <div
              [style.display]="member.visitors ? 'flex' : 'unset'"
              [style.flex-flow]="member.visitors ? 'column-reverse' : 'unset'">

              @if (!member.visitors && member.desiredStartDate) {
                <div>
                  <div class="label-section">{{ 'initialPaymentDetails' | translate }}</div>
                  <div class="application-row">
                    <div class="col-label">
                      <label class="contact-label">{{ 'initialPaymentDetails' | translate }}</label>
                    </div>
                    <div id="studio_plan_info" class="col-form">
                      <div class="form-group">
                        <b>{{ 'membershipPlan' | translate }}</b>
                        @if (member.tmp.plan && member.tmp.plan[1] !== '見学予約') {
                          <p>{{ member.tmp.plan[1] }}({{ member.tmp.plan[2] }})月会費{{ member.tmp.plan[3] | number:'1.0-0' }}円(税込)</p>
                        }
                        @if (member.tmp.plan && member.tmp.plan[1] === '見学予約') {
                          <p>{{ member.reservationMenu?.menuName }}</p>
                          <p>{{ member.tmp.visitDatetime }} ～ ({{ member.reservationMenu?.requiredTime }}分)</p>
                        }
                      </div>
                      <div class="form-group">
                        <b>{{ 'startDateOfUse' | translate }}</b>
                        <p>{{ member.desiredStartDate.name }}</p>
                      </div>
                      <div class="form-group">
                        <b>{{ 'initialPaymentDate' | translate }}</b>
                        <p>{{ firstInvoiceDate | date:'yyyy年MM月dd日' }}</p>
                      </div>
                      <div class="form-group">
                        <b>{{ 'initialPaymentAmount' | translate }}</b>
                        <p>{{ member.tmp.firstInvoiceTotal | number:'1.0-0' }}円(税込)</p>
                      </div>
                      <div class="form-group">
                        <b>{{ 'breakdown' | translate }}</b>
                        @for (invoice of member.tmp.firstInvoice; track $index) {
                          <p>{{ invoice.title }} {{ invoice.amount | number:'1.0-0' }}円(税込)</p>
                        }
                        <p class="small" [innerHTML]="noteHtml"></p>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              }

              <div>
                <div class="label-section">{{ 'basicInfoInput' | translate }}</div>
                <div class="application-row">
                  <div class="col-label">
                    <label class="contact-label">{{ 'branch' | translate }}</label>
                  </div>
                  <div class="col-form">
                    <div class="form-group">
                      <p>{{ member.tmp.studio?.[1] }}</p>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>

                @if (!member.visitors) {
                  <div class="application-row">
                    <div class="col-label">
                      <label class="contact-label">{{ 'membershipCategory' | translate }}</label>
                    </div>
                    <div class="col-form">
                      <div class="form-group">
                        <b>{{ 'membershipPlan' | translate }}</b>
                        @if (member.tmp.plan && member.tmp.plan[1] !== '見学予約') {
                          <p>{{ member.tmp.plan[1] }}({{ member.tmp.plan[2] }})月会費{{ member.tmp.plan[3] | number:'1.0-0' }}円(税込)</p>
                        }
                        @if (member.tmp.plan && member.tmp.plan[1] === '見学予約') {
                          <p>{{ member.reservationMenu?.menuName }}</p>
                          <p>{{ member.tmp.visitDatetime }} ～ ({{ member.reservationMenu?.requiredTime }}分)</p>
                        }
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                }

                <div class="application-row">
                  <div class="col-label">
                    <label class="contact-label">{{ 'lastNameLabel' | translate }}</label>
                  </div>
                  <div class="col-form name-block">
                    <div class="form-group">
                      <div class="col-lg-12" style="margin-left: -30px; margin-bottom: 10px;">
                        <div class="col-lg-3"><b>{{ 'kanji' | translate }}</b></div>
                        <div class="col-lg-5">
                          <span>{{ member.lastName }}</span>&nbsp;<span>{{ member.firstName }}</span>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                      <div class="col-lg-12" style="margin-left: -30px">
                        <div class="col-lg-3"><b>{{ 'kana' | translate }}</b></div>
                        <div class="col-lg-5">
                          <span class="first-name">{{ member.lastNameKana }}</span>&nbsp;<span class="last-name">{{ member.firstNameKana }}</span>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>

                @if (member.isEntry) {
                  <div class="application-row">
                    <div class="col-label">
                      <label class="contact-label">{{ 'gender' | translate }}</label>
                    </div>
                    <div class="col-form">
                      <div class="form-group">
                        <p>{{ member.tmp.sex?.name | translate }}</p>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>

                  <div class="application-row">
                    <div class="col-label">
                      <label class="contact-label">{{ 'address' | translate }}</label>
                    </div>
                    <div class="col-form">
                      <div class="form-group">
                        <span>{{ member.zip }}</span>
                      </div>
                      <div class="form-group">
                        <p>{{ member.province }}</p>
                        <span>{{ member.city }}</span>&nbsp;<span>{{ member.area }}</span>&nbsp;<span>{{ member.address }}</span>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>

                  @if (!member.visitors) {
                    <div class="application-row">
                      <div class="col-label">
                        <label class="contact-label">{{ 'nationality' | translate }}</label>
                      </div>
                      <div class="col-form">
                        <div class="form-group">
                          <p>{{ member.tmp.nationality?.name | translate }}</p>
                          <div class="clearfix"></div>
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  }
                }

                <div class="application-row">
                  <div class="col-label">
                    <label class="contact-label">{{ 'emailAddress' | translate }}</label>
                  </div>
                  <div class="col-form">
                    <div class="form-group">
                      <p>{{ member.email }}</p>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>

                <div class="application-row">
                  <div class="col-label">
                    <label class="contact-label">{{ 'phoneNumber' | translate }}</label>
                  </div>
                  <div class="col-form">
                    <div class="form-group">
                      <p>{{ member.phone }}</p>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>

                <div class="application-row">
                  <div class="col-label">
                    <label class="contact-label">{{ 'dateOfBirth' | translate }}</label>
                  </div>
                  <div class="col-form">
                    <div class="form-group">
                      <p>{{ member.birthday }}</p>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>

              @if (!member.visitors && member.isEntry) {
                <div>
                  <div class="label-section">{{ 'selectPaymentMethod' | translate }}</div>
                  <div class="application-row">
                    <div class="col-label">
                      <label class="contact-label">{{ 'paymentMethod' | translate }}</label>
                    </div>
                    <div class="col-form">
                      <div class="form-group">
                        @if (member.payment.paymentMethod == '0') {
                          <p>{{ 'directDebit' | translate }}</p>
                        }
                        @if (member.payment.paymentMethod == '1') {
                          <p>{{ 'creditCard' | translate }}</p>
                        }
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>

                  <div class="label-section">{{ 'emergencyContact' | translate }}</div>
                  <div class="application-row">
                    <div class="col-label">
                      <label class="contact-label">{{ 'fullName' | translate }}</label>
                    </div>
                    <div class="col-form">
                      <div class="form-group">
                        <div class="col-lg-12" style="margin-left: -30px; margin-bottom: 10px;">
                          <div class="col-lg-3">{{ 'kanji' | translate }}</div>
                          <div class="col-lg-5">
                            <span>{{ member.emLastName }}</span>&nbsp;<span>{{ member.emFirstName }}</span>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div class="col-lg-12" style="margin-left: -30px;">
                          <div class="col-lg-3">{{ 'kana' | translate }}</div>
                          <div class="col-lg-5">
                            <span>{{ member.emLastNameKana }}</span>&nbsp;<span>{{ member.emFirstNameKana }}</span>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>

                  <div class="application-row">
                    <div class="col-label">
                      <label class="contact-label">{{ 'relationship' | translate }}</label>
                    </div>
                    <div class="col-form">
                      <div class="form-group">
                        <p>{{ member.tmp.relationship?.name | translate }}</p>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>

                  <div class="application-row">
                    <div class="col-label">
                      <label class="contact-label">{{ 'phoneNumber' | translate }}</label>
                    </div>
                    <div class="col-form">
                      <div class="form-group">
                        <p>{{ member.emPhone }}</p>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              }

              @if ((!member.isRegistration && member.isEntry) || member.status === 6) {
                <div>
                  <div class="label-section">
                    @if (!member.visitors) {
                      <span>{{ 'questionnaire' | translate }}</span>
                    } @else {
                      <span>ご来館アンケート</span>
                    }
                  </div>
                  @for (questionary of questionaryList; track $index) {
                    <div class="application-row">
                      <div class="col-label">
                        <label class="contact-label" style="padding-right: 15px;">{{ questionary.questionaryContent }}</label>
                      </div>
                      <div class="col-form">
                        <div class="form-group">
                          @if (questionary.freeFlg == 0) {
                            <p>{{ getSelectColumnName(questionary.selectColumns) }}</p>
                          }
                          @if (questionary.freeFlg == 1) {
                            <p>{{ questionary.selectColumns.inputMemo }}&nbsp;</p>
                          }
                          @if (questionary.selectColumns.inputMemo != undefined && questionary.freeFlg == 0) {
                            <p>{{ questionary.selectColumns.inputMemo }}&nbsp;</p>
                          }
                          <div class="clearfix"></div>
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                  }
                </div>
              }

            </div>
          </div><!-- end application -->

          <div class="text-center step3-action-buttons">
            <div class="step3-action-buttons__item">
              @if (!member.visitors && !member.isRegistration) {
                <button (click)="back()" class="btn-back-step2">{{ 'modify' | translate }}</button>
              } @else {
                <button (click)="goBack()" class="btn-back-step2">{{ 'modify' | translate }}</button>
              }
            </div>
            <div class="step3-action-buttons__item">
              @if (!member.visitors && !member.isRegistration) {
                <button
                  (click)="save()"
                  [class]="(member.tmp.plan && member.tmp.plan[1] === '見学予約') ? 'visit_btn btn-application' : 'join_btn btn-application'">
                  @if (member.studioPlanId !== 999999999 && btPaymentEnabled === 1 && member.payment.paymentMethod == '0') {
                    <span>{{ 'registerBankAccount' | translate }}</span>
                  } @else {
                    <span>{{ 'submitForm' | translate }}</span>
                  }
                </button>
              }
              @if (member.isRegistration) {
                <button (click)="register()" class="btn-application">
                  @if (btPaymentEnabled === 1 && member.payment.paymentMethod == '0') {
                    <span>{{ 'registerBankAccount' | translate }}</span>
                  } @else {
                    <span>{{ 'submitForm' | translate }}</span>
                  }
                </button>
              }
              @if (member.visitors) {
                <button (click)="saveVisitors()" class="btn-application">入力を完了する</button>
              }
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
  }
</div>
